import React from "react";
import logo from "./logo.svg";
import Header from "./components/Header";
import Balance from "./components/Balance";
import IncomeExpenses from "./components/IncomeExpenses";
import "./App.css";
import Transaction from "./components/TransactionList";
import AddTransaction from "./components/AddTransaction";
import { GlobalProvider, GlobalContext } from "./context/GlobalState";
function App() {
  return (
    <GlobalProvider>
      <Header />
      <div className="container">
        <Balance />
        <IncomeExpenses />
        <Transaction />
        <AddTransaction />
      </div>
    </GlobalProvider>
  );
}

export default App;
